module.exports = __webpack_public_path__ + "img/email.0f59b0fc.png";